export class ChangePassword {
    currentPassword!: string;
    newPassword!: string;
    newPasswordConfirmation!: string;
}